// extracted by mini-css-extract-plugin
module.exports = {"wrap":"SpecSummary_wrap__2n_nv"};